import { configureStore, combineReducers } from "@reduxjs/toolkit";
import authReducer from "./services/reducers/authReducer";
import fileTransferReducer from "./services/reducers/fileTransferReducer";
import storageSession from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import { thunk } from "redux-thunk";

const persistConfig = {
  key: "root",
  storage: storageSession,
};

const rootReducer = combineReducers({
  auth: authReducer,
  file_transfer: fileTransferReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: () => {
    return [thunk];
  },
});

export const persistor = persistStore(store);
